module.exports = __webpack_public_path__ + "ceb76dc2e8bebc0b1d0ea53b4b1390a2.ttf";